enum JobWorkerRejectedReason {
	Undefined           = 0,
	NotEnoughExperience = 1,

}

export default JobWorkerRejectedReason;